import {
    createRegisterableComponentWithData,
    ElectionDataLoader,
} from '@news-mono/web-common'
import React from 'react'
import { TheSeatEmbedWidget } from './TheSeatEmbedWidget'
import { SeatData } from '../data'

export interface TheSeatEmbedWidgetRouteProps {
    mainRef?: React.RefObject<HTMLDivElement>
    fireClickEvent?: () => void
    electorateName?: string | null
    providedData?: SeatData
    isState?: boolean
    imageBaseUrl?: string
}

export const SeatEmbedWidgetRegistration = createRegisterableComponentWithData(
    'election-seat-embed-widget',
    ElectionDataLoader,
    (props: TheSeatEmbedWidgetRouteProps, data, services) => {
        return (
            <TheSeatEmbedWidget
                data={data}
                {...props}
                imageBaseUrl={services.config.imageBaseUrl}
            />
        )
    },
)
